{
  "id": "kite-r2",
  "name": "Arden Kite R2",
  "description": "Fictional Rally2-class hatchback, gravel set-up: 1.6 turbo with 32 mm restrictor, permanent 4WD, five-speed sequential.",
  "model": "model.glb",
  "sources": [
    {
      "claim": "Rally2: 1.6 L turbo, 32 mm restrictor, 7,500 rpm limit, 1,230 kg minimum (1,390 kg with crew), 5-speed sequential, mechanical front/rear diffs, no centre diff",
      "url": "https://api.fia.com/system/files/documents/261_2026_wmsc_2026.06.23_jt-mr.pdf"
    },
    {
      "claim": "Peak torque ~420-430 N·m at 3,500-4,750 rpm, ~210-214 kW at 5,000-6,000 rpm",
      "url": "https://skoda-motorsport.com/en/skoda-fabia-rs-rally2/basic-information"
    },
    {
      "claim": "Hydraulic handbrake opens a clutch disconnecting drive to the rear axle",
      "url": "https://skoda-motorsport.com/en/what-you-need-to-know-about-fabia-r5s-drivetrain"
    },
    {
      "claim": "Wheelbase ~2,560 mm, width 1,820 mm, 15-inch gravel rims, 205/65 R15 gravel tyres",
      "url": "https://motorsport.hyundai.com/Corporate%20Site/Car%20Spec/i20%20N%20Rally2/Hyundai%20Rally2%20Tech%20Specs.pdf"
    },
    {
      "claim": "Gear ratios 2.90/2.13/1.67/1.345/1.11 with 4.20 final drive",
      "derived": "chosen for ~188-191 km/h at 7,500 rpm (gravel set); homologated ratios are not published"
    },
    {
      "claim": "Torque curve shape",
      "derived": "fitted to published peak torque/power points; restrictor choked flow caps power near 210 kW so torque falls ~1/rpm above 5,000"
    },
    {
      "claim": "59/41 weight distribution, CoG height 0.48 m, yaw inertia 2,050 kg·m²",
      "derived": "rally-prepared Fiesta lf 0.96/lr 1.53 m (Velenis et al. CDC-ECC 2011); Iz scaled from 2,000 kg·m² at 1,300 kg"
    },
    {
      "claim": "Wheel rates 32/25 N/mm, 240 mm travel",
      "derived": "corner sprung mass × (2π·1.5 Hz)²; travel not published"
    },
    {
      "claim": "Aero CdA 0.85 m², ClA −0.3 m²",
      "derived": "Cd 0.40 × 2.1 m² frontal area; modest wing downforce"
    },
    {
      "claim": "Wheel+tyre+disc inertia 1.15 kg·m², engine+flywheel 0.12 kg·m²",
      "derived": "tyre ~11 kg at r_g 0.27 m + rim at 0.17 m + disc; crank+twin-plate clutch"
    }
  ],
  "chassis": {
    "mass": 1390,
    "inertia": [
      1950,
      2050,
      520
    ],
    "centerOfMass": [
      0,
      0.48,
      0.23
    ],
    "hull": [
      [
        0.88,
        0.3,
        2.02
      ],
      [
        -0.88,
        0.3,
        2.02
      ],
      [
        0.88,
        0.3,
        -1.98
      ],
      [
        -0.88,
        0.3,
        -1.98
      ],
      [
        0.91,
        0.62,
        2.06
      ],
      [
        -0.91,
        0.62,
        2.06
      ],
      [
        0.91,
        0.78,
        -2.02
      ],
      [
        -0.91,
        0.78,
        -2.02
      ],
      [
        0.86,
        0.95,
        1.1
      ],
      [
        -0.86,
        0.95,
        1.1
      ],
      [
        0.7,
        1.4,
        0.35
      ],
      [
        -0.7,
        1.4,
        0.35
      ],
      [
        0.7,
        1.42,
        -1.25
      ],
      [
        -0.7,
        1.42,
        -1.25
      ],
      [
        0.82,
        1.05,
        -1.95
      ],
      [
        -0.82,
        1.05,
        -1.95
      ],
      [
        0.7,
        0.22,
        1.6
      ],
      [
        -0.7,
        0.22,
        1.6
      ],
      [
        0.7,
        0.24,
        -1.55
      ],
      [
        -0.7,
        0.24,
        -1.55
      ]
    ],
    "dragArea": 0.85,
    "liftAreaFront": -0.14,
    "liftAreaRear": -0.16,
    "rollCenterHeight": 0.12
  },
  "wheels": [
    {
      "position": [
        0.8,
        0.205,
        1.28
      ],
      "axle": "front",
      "side": "left"
    },
    {
      "position": [
        -0.8,
        0.205,
        1.28
      ],
      "axle": "front",
      "side": "right"
    },
    {
      "position": [
        0.8,
        0.205,
        -1.28
      ],
      "axle": "rear",
      "side": "left"
    },
    {
      "position": [
        -0.8,
        0.205,
        -1.28
      ],
      "axle": "rear",
      "side": "right"
    }
  ],
  "tyre": {
    "compound": "gravel",
    "radius": 0.315,
    "width": 0.205,
    "inertia": 1.15,
    "relaxationLong": 0.25,
    "relaxationLat": 0.45,
    "loadSensitivity": 0.08,
    "nominalLoad": 3400,
    "lateralGripRatio": 0.96,
    "surfaceGrip": {
      "tarmac": 0.98,
      "concrete": 0.98
    },
    "surfaceSlip": {}
  },
  "suspension": {
    "front": {
      "travel": 0.24,
      "springRate": 32000,
      "preload": 500,
      "bumpDamping": 3600,
      "reboundDamping": 5200,
      "dampingKnee": 0.25,
      "highSpeedFactor": 0.45,
      "bumpStopLength": 0.03,
      "bumpStopRate": 260000,
      "antiRollRate": 5000
    },
    "rear": {
      "travel": 0.24,
      "springRate": 25000,
      "preload": 45,
      "bumpDamping": 2900,
      "reboundDamping": 4200,
      "dampingKnee": 0.25,
      "highSpeedFactor": 0.45,
      "bumpStopLength": 0.03,
      "bumpStopRate": 220000,
      "antiRollRate": 7000
    }
  },
  "steering": {
    "maxAngleDeg": 30,
    "ratio": 12,
    "ackermann": 0.5
  },
  "engine": {
    "idleRpm": 1100,
    "limiterRpm": 7500,
    "torqueCurve": [
      [
        0,
        120
      ],
      [
        1000,
        160
      ],
      [
        1500,
        200
      ],
      [
        2500,
        330
      ],
      [
        3000,
        400
      ],
      [
        3500,
        430
      ],
      [
        4750,
        430
      ],
      [
        5000,
        410
      ],
      [
        5500,
        370
      ],
      [
        6000,
        335
      ],
      [
        6500,
        300
      ],
      [
        7000,
        270
      ],
      [
        7500,
        245
      ],
      [
        8000,
        200
      ]
    ],
    "naTorqueFraction": 0.42,
    "inertia": 0.12,
    "frictionTorque": [
      12,
      4
    ],
    "engineBrakeTorque": 55,
    "turbo": {
      "spoolUpTime": 0.45,
      "spoolDownTime": 0.3,
      "boostStartRpm": 1800,
      "boostFullRpm": 3400,
      "antiLagBoost": 0.7,
      "antiLagMinRpm": 3000
    }
  },
  "gearbox": {
    "ratios": [
      2.9,
      2.13,
      1.67,
      1.345,
      1.11
    ],
    "reverse": 3,
    "finalDrive": 4.2,
    "shiftTime": 0.06,
    "efficiency": 0.9,
    "autoUpRpm": 7150,
    "autoDownRpm": 3900
  },
  "clutch": {
    "maxTorque": 900,
    "engageRpm": 1300,
    "fullRpm": 2100,
    "launchRpm": 4200
  },
  "diffs": {
    "front": {
      "preload": 10,
      "powerRamp": 0.12,
      "coastRamp": 0.08
    },
    "rear": {
      "preload": 30,
      "powerRamp": 0.3,
      "coastRamp": 0.15
    }
  },
  "brakes": {
    "maxTorque": 7000,
    "frontBias": 0.6,
    "handbrakeTorque": 3200
  }
}
